export default {
  title: "CBAM 快速查詢",
  subtitle: {
    noReg: "無需註冊",
    free: "免費",
    minutes: "1 分鐘",
  },
  steps: {
    country: "國家",
    product: "商品",
    volume: "進口量",
    result: "結果",
  },
  step1: {
    title: "您是從歐盟外進口到歐盟，還是歐盟內貿易？",
    outsideEU: "歐盟外進口",
    insideEU: "歐盟內（豁免）",
  },
  step2: {
    title: "主要進口商品？（多選支援）",
    steel: "鋼鐵",
    aluminum: "鋁",
    cement: "水泥",
    fertilizer: "化肥",
    electricity: "電力",
    hydrogen: "氫",
    other: "其他",
  },
  step3: {
    title: "2026 年預計歐盟進口量？",
    lt50t: "< 50 噸（豁免）",
    between50_500t: "50–500 噸",
    gt500t: "> 500 噸",
  },
  result: {
    lowRisk: "低風險",
    mediumRisk: "中風險",
    highRisk: "高風險",
    insideEU: "恭喜！歐盟內貿易豁免，無需報告/付款。但建議監控變化。",
    outsideEU: "恭喜！年 < 50 噸豁免或非涵蓋商品，無需報告/付款。但建議監控變化。",
    highRiskDesc: "必須報告 + 購買證書（基於排放），誤差 > 10% 罰款 €1K–€10K。",
    mediumRiskDesc: "需季度報告，2026 起可能付費。推薦生成 PwC 格式報告避風險。",
  },
  whyChoose: {
    title: "為什麼選擇 TaxEcoBit？",
    description: "TaxEcoBit 幫您 90%+ 精度計算，3 秒出合規 PDF/Excel。",
    features: {
      accurate: "精準合規：誤差 <10%，符合 CBAM 要求",
      fast: "快速出報告：3 秒生成合規 PDF/Excel",
      cost: "成本優勢：€99/月，遠低於競爭對手 €500+/月",
      trial: "免費試用 14 天，體驗所有高級功能",
    },
  },
  newRule: "2026 新規：年 < 50 噸豁免（氫/電力除外），但報告仍需精準避罰款。",
  buttons: {
    prev: "上一步",
    next: "下一步",
    viewResult: "查看結果",
    generateReport: "生成完整報告（免費註冊/試用）",
    restart: "重新開始",
  },
};
